import { ECitizenRead } from "@/Interface/Api/ECitizenInterface";
import keys from "@/locales";
import { INavBarItem } from "../interface";

export const NavBarItems = (
  ECitizenData: ECitizenRead[] = []
): INavBarItem[] => {
  return [
    {
      id: 1,
      label: keys["Header.NavLink.0"],
      route: ["/"],
    },
    {
      id: 2,
      label: keys["Header.NavLink.1"],
      route: ["/history"],
    },
    {
      id: 3,
      label: keys["Header.NavLink.10"],
      route: ["/user_citizen_charter"],
    },
    {
      id: 4,
      label: keys["Header.NavLink.11"],
      route: ["/programs&schemes"],
    },
    {
      id: 5,
      label: keys["Header.NavLink.12"],
      route: [""],
      subItem: [
        ...ECitizenData.map((item) => ({
          id: item.id,
          label: item.title,
          route: [`/showECitizen/${item.title}/${item.id}`],
        })),
        {
          id: 10,
          label: keys["Home.Service.Content_Link2"],
          route: ["/showECitizen/important_government_resolution"],
        },
        {
          id: 11,
          label: keys["Header.NavLink.6"],
          route: ["/showECitizen/100_days_program"],
        },
      ],
    },
    {
      id: 12,
      label: keys["Header.NavLink.8"],
      route: ["/photo_gallery"],
    },
    {
      id: 13,
      label: keys["Header.NavLink.15"],
      route: ["/dashboard"],
    },
    {
      id: 14,
      label: keys["Header.NavLink.5"],
      route: ["/right_to_service"],
    },
    {
      id: 15,
      label: keys["Header.NavLink.18"],
      route: ["/aaple_sarkar"],
    },
    {
      id: 17,
      label: keys["Header.NavLink.9"],
      route: ["/contact"],
    },
  ];
};

export const initialFilterValues = {
  query: "",
};
